module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal-center",
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "id": "modal-center",
      "centered": "",
      "title": _vm.$t('titles.title_transition'),
      "ok-only": true,
      "ok-title": _vm.$t('button.validate')
    },
    on: {
      "ok": function($event) {},
      "hidden": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('section', {
    attrs: {
      "id": "contentIn"
    }
  }, [_c('div', {
    staticClass: "mode_transition",
    class: {
      selected: _vm.transition === 'no-transition'
    },
    attrs: {
      "id": "no-transition-in"
    },
    on: {
      "click": function($event) {
        return _vm.setTransition('no-transition')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icons/transitions/none.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label mt-2"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.without_transition')))])]), _vm._v(" "), _c('div', {
    staticClass: "mode_transition",
    class: {
      selected: _vm.transition === 'slide'
    },
    attrs: {
      "id": "transition-right-in"
    },
    on: {
      "click": function($event) {
        return _vm.setTransition('slide')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icons/transitions/slide.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label mt-2"
  }, [_vm._v("Slide")])]), _vm._v(" "), _c('div', {
    staticClass: "mode_transition full",
    class: {
      selected: _vm.transition === 'convex'
    },
    attrs: {
      "id": "transition-left-in"
    },
    on: {
      "click": function($event) {
        return _vm.setTransition('convex')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icons/transitions/convex.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label mt-2"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.convex')))])]), _vm._v(" "), _c('div', {
    staticClass: "mode_transition top",
    class: {
      selected: _vm.transition === 'concave'
    },
    attrs: {
      "id": "transition-top-in"
    },
    on: {
      "click": function($event) {
        return _vm.setTransition('concave')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icons/transitions/concave.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label mt-2"
  }, [_vm._v("Concave")])]), _vm._v(" "), _c('div', {
    staticClass: "mode_transition bottom",
    class: {
      selected: _vm.transition === 'fade'
    },
    attrs: {
      "id": "transition-bottom-in"
    },
    on: {
      "click": function($event) {
        return _vm.setTransition('fade')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icons/transitions/fade.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label mt-2"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.fade-in')))])]), _vm._v(" "), _c('div', {
    staticClass: "mode_transition zoom",
    class: {
      selected: _vm.transition === 'zoom'
    },
    attrs: {
      "id": "transition-zoom-in"
    },
    on: {
      "click": function($event) {
        return _vm.setTransition('zoom')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icons/transitions/zoom.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label mt-2"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.grow')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aa8ffa7","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/TransitionModal.vue
// module id = 814
// module chunks = 1 3